module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/subcategoria-producto/subcategoria-producto.component.scss
// module id = ./src/app/productos/subcategoria-producto/subcategoria-producto.component.scss
// module chunks = main